import React from 'react';
import { TextLarge } from '../../components/text';
import { CardTheme } from '../../components/card';
import { ResponsivePageLayout } from '../../components/page/responsive-layout/ResponsivePageLayout';
import { Icon } from '../../resources';
import { useGetReportWarrantyList } from './hooks/useGetReportWarrantyList';
import { ContainerButton } from '../../styles/global-style';
import ButtonExcelEmbedded from '../../components/report-excel/ButtonExcelEmbedded';

import { ResponsiveTableLayout } from '../../components/page/responsive-layout/views/ResponsiveTableLayout';
import { SpaceBetween, StyledContainer } from '../../components/container/styles';

export const ReportWarranty = () => {
  const {
    formSearch,
    formSearchObj,
    dataDate,
    isLoading,
    columnsData,
    dataClaimFull,
    loadingClaimFull,
    searchType,
    onSearchByField,
    formatDataForExcel,
    createExpandableHeaders,
    columnsExpandableData,
  } = useGetReportWarrantyList();

  return (
    <StyledContainer>
      <TextLarge text="รายงานประวัติการลงทะเบียน" />
      <CardTheme>
        <ResponsivePageLayout
          searchLayout={{
            title: 'ค้นหารายงานประวัติการลงทะเบียน',
            icon: <Icon.Todo />,
            formSearch,
            useFormParam: formSearchObj,
            onSearch: formSearchObj.handleSubmit(onSearchByField),
            onClear: formSearchObj.reset,
          }}
          tableLayout={{
            columns: columnsData || [],
            dataSource: searchType === 'date' ? dataDate : dataClaimFull || [],
            loading: searchType === 'date' ? isLoading : loadingClaimFull,
            rowKey: 'rowNumber',
            hasPagination: true,
            expandable: {
              expandedRowRender: (record) => {
                const dataWarrantyReportHistoryDetails = record?.warrantyHistory || [];
                return (
                  <ResponsiveTableLayout
                    columns={columnsExpandableData}
                    dataSource={dataWarrantyReportHistoryDetails}
                    loading={isLoading}
                  />
                );
              },
            },
            extraContent: (
              <SpaceBetween>
                <ContainerButton right>
                  <ButtonExcelEmbedded
                    title="Export"
                    filename="รายงานประวัติการลงทะเบียน"
                    header={[
                      { title: 'ชื่อ-นามสกุล', dataIndex: 'ชื่อ-นามสกุล' },
                      { title: 'เบอร์โทร', dataIndex: 'เบอร์โทร' },
                      { title: 'จำนวนการลงทะเบียน', dataIndex: 'จำนวนการลงทะเบียน' },
                      { title: 'วันที่ลงทะเบียนล่าสุด', dataIndex: 'วันที่ลงทะเบียนล่าสุด' },
                      ...createExpandableHeaders(),
                    ]}
                    data={formatDataForExcel(
                      searchType === 'date' ? dataDate : dataClaimFull || [],
                    )}
                  />
                </ContainerButton>
              </SpaceBetween>
            ),
          }}
        />
      </CardTheme>
    </StyledContainer>
  );
};
